import React from "react";
import { Typography } from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";

import { INoDataProps } from "./types";

const useStyles = makeStyles(({ brand, spacing }) => ({
  wrapper: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    height: "100px",
    border: `1px dashed ${brand.stormyBlue[20]}`,
    color: brand.stormyBlue[60],
    margin: spacing(3)
  }
}));

export const NoData = ({ label }: INoDataProps) => {
  const classes = useStyles();
  return (
    <Typography variant="h4" className={classes.wrapper}>
      {label}
    </Typography>
  );
};
